import React, { useState } from "react";
import axios from "axios";
import "./Withdraw.css";
import BackButton from "./BackButton";

const Withdraw = () => {
    const [formData, setFormData] = useState({
        amount: "",
        method: "JazzCash",
        accountDetails: ""
    });
    const [message, setMessage] = useState({ text: "", type: "" });
    const [isSubmitting, setIsSubmitting] = useState(false);

    const paymentMethods = [
        { value: "JazzCash", label: "JazzCash" },
        { value: "EasyPaisa", label: "EasyPaisa" }
    ];

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleWithdraw = async (e) => {
        e.preventDefault();
        setMessage({ text: "", type: "" });

        if (!formData.amount || !formData.accountDetails) {
            setMessage({ text: "Please fill in all fields.", type: "error" });
            return;
        }

        if (parseFloat(formData.amount) <= 0) {
            setMessage({ text: "Amount must be greater than 0.", type: "error" });
            return;
        }

        setIsSubmitting(true);

        try {
            const res = await axios.post(
                "https://backend.aubattle.com/api/withdraw",
                { 
                    amount: formData.amount, 
                    method: formData.method, 
                    account_details: formData.accountDetails 
                },
                { 
                    headers: { 
                        Authorization: `Bearer ${localStorage.getItem("token")}` 
                    } 
                }
            );

            setMessage({ text: res.data.message, type: "success" });
            setFormData({
                amount: "",
                method: "JazzCash",
                accountDetails: ""
            });
        } catch (error) {
            console.error("Withdraw request failed:", error);
            const errorMsg = error.response?.data?.message || "Withdrawal request failed. Please try again later.";
            setMessage({ text: errorMsg, type: "error" });
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="withdraw-dark-container">
            <div className="withdraw-dark-header">
                <BackButton darkMode />
                <h2 className="withdraw-dark-title">Withdraw Funds</h2>
            </div>
            
            {message.text && (
                <div className={`withdraw-dark-message ${message.type}`}>
                    <div className="message-icon">
                        {message.type === "success" ? "✓" : "!"}
                    </div>
                    {message.text}
                </div>
            )}

            <form onSubmit={handleWithdraw} className="withdraw-dark-form">
                <div className="form-dark-group">
                    <label htmlFor="amount">Amount (PKR)</label>
                    <input
                        id="amount"
                        type="number"
                        name="amount"
                        value={formData.amount}
                        onChange={handleChange}
                        min="1"
                        placeholder="500"
                        required
                    />
                </div>

                <div className="form-dark-group">
                    <label htmlFor="method">Payment Method</label>
                    <div className="select-dark-wrapper">
                        <select 
                            id="method"
                            name="method"
                            value={formData.method}
                            onChange={handleChange}
                            required
                            className="dark-select"
                        >
                            {paymentMethods.map(method => (
                                <option key={method.value} value={method.value}>
                                    {method.label}
                                </option>
                            ))}
                        </select>
                        <span className="select-dark-arrow">▼</span>
                    </div>
                </div>

                <div className="form-dark-group">
                    <label htmlFor="accountDetails">
                        {formData.method === "JazzCash" || formData.method === "EasyPaisa" 
                            ? "Account Details" 
                            : "Account Details"}
                    </label>
                    <input
                        id="accountDetails"
                        type="text"
                        name="accountDetails"
                        value={formData.accountDetails}
                        onChange={handleChange}
                        placeholder={
                            formData.method === "JazzCash" || formData.method === "EasyPaisa" 
                                ? "03001234567 / Ahad Raees" 
                                : "Account number/name"
                        }
                        required
                    />
                </div>

                <button 
                    type="submit" 
                    className="submit-dark-button"
                    disabled={isSubmitting}
                >
                    {isSubmitting ? (
                        <span className="button-dark-loader"></span>
                    ) : (
                        "Request Withdrawal"
                    )}
                </button>
            </form>

            <div className="withdraw-dark-info">
                <div className="info-dark-header">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <circle cx="12" cy="12" r="10"></circle>
                        <line x1="12" y1="16" x2="12" y2="12"></line>
                        <line x1="12" y1="8" x2="12" y2="8"></line>
                    </svg>
                    <h4>Withdrawal Information</h4>
                </div>
                <ul className="info-dark-list">
                    <li>• Minimum withdrawal: <span>500 PKR</span></li>
                    <li>• Processing time: <span>24-48 hours</span></li>
                    <li>• Double-check your details</li>
                </ul>
            </div>
        </div>
    );
};

export default Withdraw;